if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".f-product-form__error-message-wrapper",
          customFields: ["[data-product-custom-field]"],
        };

        this.domNodes = queryDomNodes(this.selectors, this);

        this.form = this.domNodes.form;
        this.submitButton = this.domNodes.submitButton;
        // Constructed without markup (e.g. an extension re-creating the
        // element to inspect the page) leaves no input to enable.
        if (this.domNodes.inputId) this.domNodes.inputId.disabled = false;
        this.Notification = window.FoxTheme.Notification;
        this.notificationType = this.dataset.notificationType;
        this.customFields = document.querySelectorAll(
          this.selectors.customFields
        );
        this.cartDrawer = document.querySelector("cart-drawer");
        this.mainCart = document.querySelector("cart-items");
        this.type = this.dataset.type;

        this.variantIdInput = this.domNodes.inputId;

        this.errorWrapper =
          this.type === "product-card"
            ? this.closest(".product-card")
            : this.domNodes.errorWrapper;

        this.form &&
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        if (this.submitButton?.hasAttribute("data-product-form-pending") && this.form && this.variantIdInput) {
          this.submitButton.removeAttribute("data-product-form-pending");
          this.submitButton.disabled = false;
        }
      }

      validateForm(form) {
        const missingFields = [];
        if (!form) return missingFields;
        const fieldSelectors =
          '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
        const requiredFields = form.querySelectorAll(fieldSelectors);
        requiredFields.forEach((field) => {
          field.classList.remove("form-control--warning");
          if (field.type === "radio") {
            const buttons = form.querySelectorAll(
              `input[name="${field.name}"]`
            );
            const selected = Array.from(buttons).some((btn) => btn.checked);
            if (!selected) {
              missingFields.push(field);
              field.classList.add("form-control--warning");
            }
          } else if (!field.value) {
            missingFields.push(field);
            field.classList.add("form-control--warning");
          }
        });
        return missingFields;
      }

      validatePreparedMto(prepared) {
        const root = this.closest('product-info')?.querySelector('[data-mto-form]') ||
          (this.closest('#shopify-section-sticky-atc-bar') && document.querySelector('[data-mto-form]'));
        if (!root) return !this.classList.contains('dummy-product-form');
        if (!prepared || String(prepared.variantId) !== String(this.variantIdInput.value)) return false;
        const parts = ['width.ft', 'width.inch', 'length.ft', 'length.inch'].map(key =>
          root.querySelector(`[x-model="selected.${key}"]`)?.value);
        if (parts.some(value => value == null || value.trim() === '' || !Number.isInteger(Number(value)))) return false;
        const [wf, wi, lf, li] = parts.map(Number);
        const expected = prepared.selection;
        if (!expected || wf !== Number(expected.width.ft) || wi !== Number(expected.width.inch) ||
            lf !== Number(expected.length.ft) || li !== Number(expected.length.inch)) return false;
        return wi >= 0 && wi <= 11 && li >= 0 && li <= 11 &&
          wf * 12 + wi >= prepared.minWidth && wf * 12 + wi <= 300 &&
          lf * 12 + li >= prepared.minLength && lf * 12 + li <= 600;
      }

      async readyCartSections(response, sections) {
        const ids = [...new Set(sections)].filter(Boolean);
        if (!ids.length) return response;
        const keys = (response.items || [response]).map(item => item.key).filter(Boolean);
        const complete = (rendered) => {
          const documents = ids.map(id => typeof rendered?.[id] === "string"
            ? new DOMParser().parseFromString(rendered[id], "text/html") : null);
          return documents.every(doc => doc && doc.body.children.length && !doc.querySelector('[data-milagro-incomplete-item]')) &&
            keys.every(key => documents.some(doc => Array.from(doc.querySelectorAll('[data-cart-item]'))
              .some(item => item.getAttribute('data-cart-item') === key)));
        };
        if (complete(response.sections)) return response;
        const deadline = Date.now() + 15000;
        const root = window.Shopify?.routes?.root || '/';
        for (let attempt = 0; attempt < 10 && Date.now() < deadline; attempt++) {
          try {
            const params = new URLSearchParams({ sections: ids.join(','), _milagro: String(Date.now()) });
            const fresh = await fetch(root + 'cart?' + params, {
              cache: 'no-store', signal: AbortSignal.timeout(Math.max(1, Math.min(3000, deadline - Date.now())))
            });
            if (fresh.ok) {
              const rendered = await fresh.json();
              if (complete(rendered)) return { ...response, sections: rendered };
            }
          } catch (error) {
            console.warn('Cart details are still loading', error);
          }
          if (attempt < 9 && Date.now() + 500 < deadline) {
            await new Promise(resolve => setTimeout(resolve, 500));
          }
        }
        return response;
      }

      onSubmitHandler(evt, additionalItems = [], preparedMto = null) {
        evt.preventDefault();
        if (!this.validatePreparedMto(preparedMto)) {
          this.error = true;
          return;
        }
        const missing = this.validateForm(
          this.form.closest(".f-product-single__blocks")
        );

        if (missing && missing.length > 0) {
          return this.Notification.show({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.FoxThemeStrings.requiredField,
          });
        }

        if (this.submitButton.classList.contains("btn--loading")) return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("btn--loading");

        const config = {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
        };

        const formData = new FormData(this.form);
        if (this.form.id === 'product-form-sticky-atc-bar') {
          const leadTime = document.querySelector('product-info input[name="properties[Estimated ship time]"]');
          if (leadTime?.value) formData.set('properties[Estimated ship time]', leadTime.value);
        }
        const mainVariantId = formData.get("id");
        if (additionalItems.length) {
          for (const [key, value] of Array.from(formData.entries())) {
            if (key === "id" || key === "quantity" || key === "selling_plan" || key.startsWith("properties[")) {
              formData.delete(key);
              const indexedKey = key.startsWith("properties[")
                ? `items[0][properties]${key.slice(10)}`
                : `items[0][${key}]`;
              formData.append(indexedKey, value);
            }
          }
          if (!formData.has("items[0][quantity]")) formData.append("items[0][quantity]", "1");
          additionalItems.forEach((item, index) => {
            const prefix = `items[${index + 1}]`;
            formData.append(`${prefix}[id]`, item.id);
            formData.append(`${prefix}[quantity]`, String(item.quantity || 1));
            Object.entries(item.properties || {}).forEach(([key, value]) => formData.append(`${prefix}[properties][${key}]`, value));
          });
        }

        let sectionToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", {
            bubbles: true,
            detail: { sections: sectionToBundle },
          })
        );

        if (this.cartDrawer) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.cartDrawer
              .getSectionsToRender()
              .map((section) => section.id),
          ];
        }

        if (this.mainCart) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.mainCart
              .getSectionsToRender()
              .map((section) => section.section),
          ];
        }

        formData.append("sections", sectionToBundle);

        if (this.mainCart || this.cartDrawer) {
          formData.append("sections_url", window.location.pathname);
        }

        config.body = formData;
        config.signal = AbortSignal.timeout(20000);
        const { FoxThemeSettings, FoxThemeStrings } = window;
        return fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.items?.length && !response.status) {
              response = { ...response.items[0], ...response };
            }
            if (response.status) {
              window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: mainVariantId,
                errors: response.description,
                message: response.message,
              });

              // Dispatch event for third-party
              document.dispatchEvent(
                new CustomEvent("product-ajax:error", {
                  detail: {
                    errorMessage: response.description,
                  },
                })
              );

              this.error = true;
              return this.Notification.show({
                target:
                  this.notificationType === "toast"
                    ? document.body
                    : this.errorWrapper,
                method: "appendChild",
                type: "warning",
                message: response.description || response.message,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }

            response = await this.readyCartSections(response, sectionToBundle);

            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper ? this.errorWrapper : document.body,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }
            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }

            this.error = false;
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);

            // DispatchEvent for third-party
            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                detail: {
                  product: response,
                },
              })
            );
            return response;
          })
          .catch((e) => {
            this.error = true;
            console.error(e);
            this.Notification.show({
              target: this.errorWrapper || document.body,
              method: "appendChild", type: "warning",
              message: "We couldn’t confirm your cart update. Please check your cart before trying again.",
              last: 8000, sticky: this.notificationType === "toast",
            });
          })
          .finally(() => {
            this.submitButton.classList.remove("btn--loading");
            this.submitButton.removeAttribute("aria-disabled");
          });
      }
    }
  );
}




